import SolidBoltAltIcon from 'LuxKit/Icons/solid/SolidBoltAltIcon'
import NeutralLabel from 'LuxKit/Label/NeutralLabel'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { FormattedMessage } from 'react-intl'
import type { BookingLabelThreshold } from './urgencyLabelVisibility'
import { shouldShowBookingsCountLabel } from './urgencyLabelVisibility'

interface Props {
  /**
   * The number of bookings that have been made
   */
  bookings: number
  /**
   * The threshhold to apply to the booking counts
   * Internally this label knows what they are, you just
   * pass what type of threshold you want
   */
  threshold: BookingLabelThreshold
}

function BookingsCountLabel(props: Props) {
  const { bookings, threshold } = props

  if (!shouldShowBookingsCountLabel(bookings, threshold)) {
    return null
  }

  return <NeutralLabel
    startIcon={<SolidBoltAltIcon />}
  >
    <FormattedMessage
      id="XmrWPxbdO4_JlzlLA9ip"
      defaultMessage="Booked {bookingCount} times in 3 days"
      description="Neutral label showing recent booking count for social proof"
      values={{ bookingCount: <FormatDecimal value={bookings} /> }}
    />
  </NeutralLabel>
}

export default BookingsCountLabel
